import { render, staticRenderFns } from "./ProspectToday.vue?vue&type=template&id=485cead7"
import script from "./ProspectToday.vue?vue&type=script&lang=js"
export * from "./ProspectToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports